import { IShipmentInvoice } from "@/types/apiResponse.types";

const getMimeType = (ext: string) => {
  const map: Record<string, string> = {
    pdf: "application/pdf",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    txt: "text/plain",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  };
  return map[ext.toLowerCase()] || "application/octet-stream";
};

export const openInvoiceFile = (invoiceFileData: IShipmentInvoice) => {
  const invoiceFile = invoiceFileData;

  // Convert Base64 to Blob
  const byteCharacters = atob(invoiceFile.fileContentInBase64);
  const byteNumbers = Array.from(byteCharacters).map((char) =>
    char.charCodeAt(0),
  );
  const byteArray = new Uint8Array(byteNumbers);
  const mimeType = getMimeType(invoiceFile.fileExtension);
  const blob = new Blob([byteArray], { type: mimeType });

  // Open in new tab
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, "_blank");
};
